import { FeedbackRibbon } from 'owa-feedback';
import { FeedbackCategory, FeedbackDialogParams } from 'owa-feedback';
import loc from 'owa-localize';
import { NudgedReason } from 'owa-mail-nudge-store';
import removeInfoBarMessage from 'owa-info-bar/lib/actions/removeInfoBarMessage';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import * as React from 'react';
import {
    nudgeFeedbackRequest,
    nudgeMoreFeedbackRibbonMessage,
    nudgeFeedbackDialogTitle,
    nudgeFeedbackDialogDetail,
    nudgeFeedbackCategoryIrrelevantFollowUp,
    nudgeFeedbackCategoryIrrelevantReply,
    nudgeFeedbackCategoryUnnecessary,
    nudgeFeedbackCategoryFrequency,
    nudgeFeedbackCategoryDoNotWant,
    nudgeFeedbackCategoryOther,
    nudgeFeedbackDialogGhostText,
    nudgeFeedbackDonationText,
    nudgeFeedbackDonationTooltip,
} from './getFeedbackRibbonForNudgeInfoBar.locstring.json';

const styles = require('./getFeedbackRibbonForNudgeInfoBar.scss');

export const getFeedbackRibbonForNudgeInfoBar = (
    itemViewState: ItemViewState,
    key: string,
    nudgedReason: NudgedReason,
    donationJson: string
): JSX.Element => {
    const removeInfoBar = () => {
        removeInfoBarMessage(itemViewState, key);
    };

    let nudgeIrrelevantString;
    let nudgeSubfeature;

    if (nudgedReason === NudgedReason.ReceivedDaysAgo) {
        nudgeIrrelevantString = loc(nudgeFeedbackCategoryIrrelevantReply);
        nudgeSubfeature = 'Reply';
    } else {
        nudgeIrrelevantString = loc(nudgeFeedbackCategoryIrrelevantFollowUp);
        nudgeSubfeature = 'FollowUp';
    }

    const feedbackCategories: FeedbackCategory[] = [
        { logString: 'Irrelevant', uiString: nudgeIrrelevantString },
        { logString: 'Unnecessary', uiString: loc(nudgeFeedbackCategoryUnnecessary) },
        { logString: 'Do not want', uiString: loc(nudgeFeedbackCategoryDoNotWant) },
        { logString: 'Frequency', uiString: loc(nudgeFeedbackCategoryFrequency) },
        { logString: 'Other', uiString: loc(nudgeFeedbackCategoryOther) },
    ];

    const feedbackDialogParams: FeedbackDialogParams = {
        title: loc(nudgeFeedbackDialogTitle),
        subTitle: loc(nudgeFeedbackDialogDetail),
        categories: feedbackCategories,
        ghostText: loc(nudgeFeedbackDialogGhostText),
        donationText: loc(nudgeFeedbackDonationText),
        donationToolTip: loc(nudgeFeedbackDonationTooltip),
        donationJson: donationJson,
    };

    return (
        <div className={styles.nudgeFeedbackRibbon}>
            <FeedbackRibbon
                feature="Nudge"
                subFeature={nudgeSubfeature}
                ribbonMessage={loc(nudgeFeedbackRequest)}
                moreFeedbackRibbonMessage={loc(nudgeMoreFeedbackRibbonMessage)}
                okCallBack={removeInfoBar}
                notNowCallBack={removeInfoBar}
                noFeedbackDialogParams={feedbackDialogParams}
                hideRibbonIconDiv={true}
            />
        </div>
    );
};
